import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { updateFilters, updateBaseFilters, setSelectedTab } from '../../../reducers/filtersSlice';
import FadeIn from '../../../components/FadeIn';

import { rightArrowSVG } from '../../../../assets/svgIcons';

export const Dropdown = ({ title, tab, children }) => {
  const { baseCollection, selectedTab, hasUnsavedFilters } = useSelector((state) => state.filters);
  const { totalPrevision, requestPrevisionsState } = useSelector((state) => state.properties);
  const dispatch = useDispatch();
  const isOpen = selectedTab === tab

  const handleSubmit = () => {
    dispatch(updateBaseFilters())
    dispatch(setSelectedTab(null))
    pushDataLayer();
  }

  const pushDataLayer = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'search_properties',
      ...baseCollection
    })
  }

  const handleCancel = () => {
    dispatch(updateFilters(baseCollection))
    dispatch(setSelectedTab(null))
  }

  if (!isOpen) return null;

  return(
    <FadeIn>
      <div className={`vesta-card ${isOpen ? 'vesta-card-open' : ''}`} id='dropdown-container'>
        <div className='vesta-h-responsive'>
          <div className='vesta-flex-col-start vesta-gap-15 vesta-padding-responsive'>
            {title && <div className='typo-h3 vesta-whitespace-nowrap vesta-indigo-100'>{title}</div>}
            {children}
          </div>

          {hasUnsavedFilters &&
            <div className='vesta-flex-row-center vesta-bg-purple-5 vesta-gap-15 vesta-padding-responsive'>
              <div className='typo-link hover:typo-link vesta-indigo-100 vesta-text-underline vesta-cursor-pointer' onClick={() => handleCancel()}>Annuler</div>

              <div className='vesta-button--primary vesta-button--small typo-button vesta-flex-row-center vesta-gap-10' onClick={() => handleSubmit()}>
                {requestPrevisionsState === 'pending' && (
                  <div className='spinner-loader-centered spinner-loader'></div>
                )}

                {requestPrevisionsState === 'done' && (
                  <>
                    {totalPrevision > 0 && (`Voir ${totalPrevision > 1 ? `les ${totalPrevision} biens` : 'le bien'}`)}
                    {totalPrevision <= 0 && ('Aucun bien')}
                    {rightArrowSVG()}
                  </>

                )}
              </div>
            </div>
          }
        </div>
      </div>
    </FadeIn>
  )
};

Dropdown.propTypes = {
  title: PropTypes.string,
  tab: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
}

export default Dropdown;
